import React, { createContext, useContext, useState } from 'react';
import ReactDOM from 'react-dom';
const DimensionContext = /*#__PURE__*/createContext({});
export const useDimension = () => {
  const [show, setShow] = useState(true);
  const context = useContext(DimensionContext);

  const resolve = value => {
    if (!context.closeManually) {
      setShow(false);
    }

    context.resolve(value);
  };

  const reject = value => {
    if (!context.closeManually) {
      setShow(false);
    }

    context.reject(value);
  };

  const close = () => {
    setShow(false);
    context.close();
  };

  return {
    show,
    resolve,
    reject,
    close
  };
};

function createDimension(Component, {
  delay,
  containerNode = document.body,
  manipulateWrapperNode,
  closeManually
}) {
  return props => {
    const finalDelay = typeof delay === 'function' ? delay(props) : delay;
    const parentNode = typeof containerNode === 'function' ? containerNode(props) : containerNode;
    let wrapperNode = document.createElement('div');

    if (typeof manipulateWrapperNode === 'function') {
      wrapperNode = manipulateWrapperNode(wrapperNode, props) || wrapperNode;
    }

    if (!parentNode.contains(wrapperNode)) {
      parentNode.appendChild(wrapperNode);
    }

    const close = () => {
      setTimeout(() => {
        ReactDOM.unmountComponentAtNode(wrapperNode);
        setTimeout(() => {
          if (parentNode.contains(wrapperNode)) {
            parentNode.removeChild(wrapperNode);
          }
        });
      }, finalDelay);
    };

    const promisify = new Promise((resolve, reject) => {
      ReactDOM.render( /*#__PURE__*/React.createElement(DimensionContext.Provider, {
        value: {
          resolve,
          reject,
          close,
          closeManually
        }
      }, /*#__PURE__*/React.createElement(Component, props)), wrapperNode);
    });
    return promisify.then(value => {
      if (!closeManually) {
        close();
      }

      return value;
    }).catch(value => {
      if (!closeManually) {
        close();
      }

      return Promise.reject(value);
    });
  };
}

export default createDimension;